import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {
  Field,
  FieldArray,
} from 'formik';
import {
  InputFormField,
} from '@playbookux/playbook-web-core';

import {
  AnswersContainer,
  InputAnswerContainer,

} from '../../styles';

const MatrixField = (props) => {
  const {
    matrixOption,
    question,
    index,
    taskIndex,
  } = props;

  let label = '';
  let nameFieldArray = '';
  let questionOptions = null;

  nameFieldArray = `${(taskIndex || taskIndex === 0) ? `surveysPages[${taskIndex}]` : ''}tasks.${index}.questionOptions`;

  if (matrixOption === 'row') {
    questionOptions = _.filter(question.questionOptions, { matrixOption: 'row' });
  } else {
    questionOptions = _.filter(question.questionOptions, { matrixOption: 'column' });
  }

  return (
    <FieldArray
      name={nameFieldArray}
      render={() => (
        <>
          {questionOptions.map((option) => {
            const indexOptionFromQuestionOption = _.findIndex(question.questionOptions, { id: option.id });
            label = `${(taskIndex || taskIndex === 0)
              ? `surveysPages[${taskIndex}]` : ''}tasks.${index}.questionOptions.${indexOptionFromQuestionOption}.label`;
            return (
              <AnswersContainer>
                <InputAnswerContainer>
                  <Field
                    name={label}
                    placeholder="Type your answer here"
                    component={InputFormField}
                    widthsize="90%"
                    audience
                  />
                </InputAnswerContainer>
              </AnswersContainer>
            );
          })}
        </>
      )}
    />
  );
};

MatrixField.propTypes = {
  question: PropTypes.shape({
    questionOptions: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  matrixOption: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  taskIndex: PropTypes.number.isRequired,
};

MatrixField.defaultProps = {
};

export default React.memo(MatrixField);
